import { createIcon } from '@chakra-ui/react'

export const SearchIcon = createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 21 22',
  path: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 9.25C5.25 5.38401 8.38401 2.25 12.25 2.25C16.116 2.25 19.25 5.38401 19.25 9.25C19.25 13.116 16.116 16.25 12.25 16.25C10.6324 16.25 9.14291 15.7013 7.95756 14.7799L2.36872 20.3687C2.02701 20.7104 1.47299 20.7104 1.13128 20.3687C0.815858 20.0533 0.791595 19.557 1.05849 19.2137L1.13128 19.1313L6.72012 13.5424C5.7987 12.3571 5.25 10.8676 5.25 9.25ZM13.125 4.07259C15.3234 4.44142 17.0586 6.17656 17.4274 8.375H13.125L13.125 4.07259ZM11.375 9.25L11.375 4.07259C8.892 4.48916 7 6.64863 7 9.25C7 12.1495 9.3505 14.5 12.25 14.5C14.8514 14.5 17.0108 12.608 17.4274 10.125H12.25C11.8013 10.125 11.4314 9.78721 11.3809 9.35204L11.375 9.25Z"
        fill="white"
      />
      <path
        d="M11.375 3.125C15.241 3.125 18.375 6.25901 18.375 10.125L14.375 10.125C12.7181 10.125 11.375 8.78185 11.375 7.125L11.375 3.125Z"
        fill="white"
      />
    </g>
  ),
})
export const FinancialIcon = createIcon({
  displayName: 'FinancialIcon',
  viewBox: '0 0 34 34',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.8135 0.333332C32.8363 0.333332 33.6654 1.13692 33.6654 2.1282V21.8718C33.6654 22.8631 32.8363 23.6667 31.8135 23.6667H2.18388C1.16113 23.6667 0.332031 22.8631 0.332031 21.8718V2.1282C0.332031 1.13692 1.16113 0.333332 2.18388 0.333332H31.8135ZM30.332 3.66667H3.66536V20.3333H30.332V3.66667ZM12.832 12C14.673 12 16.1654 13.4924 16.1654 15.3333C16.1654 17.1743 14.673 18.6667 12.832 18.6667C12.0436 18.6667 11.3191 18.3929 10.7484 17.9353C10.1797 18.3924 9.45456 18.6667 8.66537 18.6667C6.82442 18.6667 5.33203 17.1743 5.33203 15.3333C5.33203 13.4924 6.82442 12 8.66537 12C9.45456 12 10.1797 12.2743 10.7507 12.7327C11.3191 12.2737 12.0436 12 12.832 12Z"
      fill="#003D4C"
    />
  ),
})
export const ChevronRight = createIcon({
  displayName: 'ChevronRight',
  viewBox: '0 0 31 30',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 30C23.7843 30 30.5 23.2843 30.5 15C30.5 6.71573 23.7843 0 15.5 0C7.21573 0 0.5 6.71573 0.5 15C0.5 23.2843 7.21573 30 15.5 30ZM10.7897 22.0502C10.3478 21.5199 10.4194 20.7317 10.9498 20.2897L17.2963 15L10.9498 9.71026L10.8356 9.6024C10.4115 9.14857 10.3818 8.4393 10.7897 7.94975C11.2317 7.41941 12.0199 7.34775 12.5502 7.78971L20.0502 14.0397L20.1622 14.145C20.6473 14.6604 20.61 15.4938 20.0502 15.9603L12.5502 22.2103L12.4236 22.3032C11.9007 22.6385 11.1977 22.5398 10.7897 22.0502Z"
      fill="currentColor"
    />
  ),
})
export const ChevronDown = createIcon({
  displayName: 'ChevronDown',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M7.7682 8.35981C7.41463 7.93553 6.78407 7.87821 6.35979 8.23177C5.96815 8.55814 5.88918 9.12053 6.15744 9.53883L6.23175 9.64018L11.2318 15.6402C11.6049 16.0879 12.2717 16.1178 12.6839 15.7297L12.7682 15.6402L17.7682 9.64018C18.1218 9.2159 18.0644 8.58534 17.6402 8.23177C17.2485 7.90541 16.6811 7.92915 16.318 8.26843L16.2318 8.35981L12 13.437L7.7682 8.35981Z"
      fill="currentColor"
    />
  ),
})

export const PoundSign = createIcon({
  displayName: 'PoundSign',
  viewBox: '0 0 8 10',
  path: (
    <path
      fill="currentColor"
      d="M6.75506 9.61557C7.23322 9.61557 7.62091 9.2408 7.62091 8.76265C7.62091 8.28449 7.23322 7.8968 6.75506 7.8968H3.61475V6.16511H5.81168C6.26399 6.16511 6.63875 5.80326 6.63875 5.35096C6.63875 4.89865 6.26399 4.52388 5.81168 4.52388H3.61475V3.5288C3.61475 3.11526 3.74399 2.77926 3.95075 2.57249C4.1446 2.37865 4.37722 2.28819 4.68737 2.28819C5.11383 2.28819 5.42399 2.45619 5.75999 2.80511C5.88922 2.93434 6.12183 3.10234 6.47075 3.10234C7.01352 3.10234 7.45291 2.67588 7.45291 2.13311C7.45291 1.81003 7.32368 1.60326 7.14276 1.42234C6.57414 0.840801 5.81168 0.440186 4.66152 0.440186C3.66645 0.440186 2.90399 0.737416 2.37414 1.26726C1.87014 1.77126 1.59875 2.54665 1.59875 3.47711V4.52388H1.36614C0.913832 4.52388 0.539062 4.89865 0.539062 5.35096C0.539062 5.80326 0.913832 6.16511 1.36614 6.16511H1.59875V7.98726L1.08183 8.15526C0.732909 8.27157 0.539062 8.5688 0.539062 8.89188C0.539062 9.29249 0.862139 9.61557 1.34029 9.61557H6.75506Z"
    />
  ),
})

export const CircleIcon = createIcon({
  displayName: 'CircleIcon',
  viewBox: '0 0 75 74',
  path: (
    <g>
      <path
        d="M74.543 37.0016C74.543 57.4353 57.9775 74 37.543 74C17.1084 74 0.542969 57.4353 0.542969 37.0016C0.542969 16.568 17.1084 0 37.543 0C57.9775 0 74.543 16.568 74.543 37.0016"
        fill="#71B2C9"
      />
    </g>
  ),
})

export const Menu = createIcon({
  displayName: 'Menu',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M22 5C22 4.44772 21.5523 4 21 4H11L10.8834 4.00673C10.386 4.06449 10 4.48716 10 5C10 5.55228 10.4477 6 11 6H21L21.1166 5.99327C21.614 5.93551 22 5.51284 22 5ZM21 11C21.5523 11 22 11.4477 22 12C22 12.5128 21.614 12.9355 21.1166 12.9933L21 13H7C6.44772 13 6 12.5523 6 12C6 11.4872 6.38604 11.0645 6.88338 11.0067L7 11H21ZM21 18C21.5523 18 22 18.4477 22 19C22 19.5128 21.614 19.9355 21.1166 19.9933L21 20H3C2.44772 20 2 19.5523 2 19C2 18.4872 2.38604 18.0645 2.88338 18.0067L3 18H21Z"
      fill="#003D4C"
    />
  ),
})

export const CustomerSearch = createIcon({
  displayName: 'CustomerSearch',
  viewBox: '0 0 38 38',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.4987 15.8332C9.4987 8.83756 15.1698 3.1665 22.1654 3.1665C29.161 3.1665 34.832 8.83756 34.832 15.8332C34.832 22.8288 29.161 28.4998 22.1654 28.4998C19.2382 28.4998 16.543 27.507 14.3981 25.8396L4.28495 35.9528C3.66662 36.5711 2.66411 36.5711 2.04578 35.9528C1.47501 35.382 1.43111 34.4839 1.91406 33.8627L2.04578 33.7136L12.1589 23.6004C10.4916 21.4555 9.4987 18.7603 9.4987 15.8332ZM23.7487 6.46452C27.7268 7.13193 30.8666 10.2717 31.534 14.2498L23.7487 14.2498L23.7487 6.46452ZM20.582 15.8332L20.582 6.46452C16.089 7.21831 12.6654 11.1259 12.6654 15.8332C12.6654 21.0799 16.9187 25.3332 22.1654 25.3332C26.8726 25.3332 30.7802 21.9095 31.534 17.4165H22.1654C21.3534 17.4165 20.6841 16.8053 20.5927 16.0178L20.582 15.8332Z"
      fill="#003D4C"
    />
  ),
})

export const SuccessIcon = createIcon({
  displayName: 'SuccessIcon',
  viewBox: '0 0 24 24',
  path: (
    <g>
      <path
        d="M12 2C13.9698 2 15.8572 2.5716 17.4708 3.62797C17.9329 3.93047 18.0622 4.55028 17.7597 5.01235C17.4572 5.47443 16.8374 5.60379 16.3754 5.30129C15.0849 4.45647 13.5776 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.2785 20 19.7816 16.6378 19.9902 12.4004L20 12L19.999 11.8735C19.9905 11.3213 20.4312 10.8667 20.9834 10.8582C21.5357 10.8496 21.9902 11.2904 21.9988 11.8426L21.9983 12.1869C21.8983 17.631 17.4531 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z"
        fill="#788E20"
      />
      <path
        d="M21.3668 5.22607C21.7942 4.87635 22.4242 4.93935 22.774 5.36679C23.0968 5.76136 23.0679 6.32853 22.7254 6.68853L22.6332 6.77399L11.6332 15.774C11.2688 16.0722 10.7515 16.0728 10.388 15.791L10.2929 15.7071L6.29289 11.7071C5.90237 11.3166 5.90237 10.6834 6.29289 10.2929C6.65338 9.93244 7.22061 9.90471 7.6129 10.2097L7.70711 10.2929L11.067 13.652L21.3668 5.22607Z"
        fill="#788E20"
      />
    </g>
  ),
})

export const WarningIcon = createIcon({
  displayName: 'WarningIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="none"
      d="M12 8V13M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="#D45D00"
      strokeWidth="2"
      strokeLinecap="round"
    />
  ),
})

export const TrendingIcon = createIcon({
  displayName: 'TrendingIcon',
  viewBox: '0 0 25 25',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3179 7.83121L17.036 8.08565L16.9239 8.09111C16.4796 8.08508 16.0887 7.75381 16.0108 7.31181C15.9235 6.8169 16.2581 6.36408 16.7548 6.30866L21.7412 5.7523L21.8355 5.74707C22.3575 5.75184 22.7834 6.17811 22.7801 6.68774L22.748 11.705L22.7419 11.8009C22.6803 12.2647 22.287 12.5819 21.8282 12.5498C21.3391 12.5156 20.9483 12.0984 20.9514 11.6111L20.9678 9.01747L14.719 15.0872C14.3767 15.4198 13.8487 15.4628 13.4425 15.1841L13.3356 15.0969L9.69492 11.6579L3.0497 18.2452C2.72589 18.5661 2.23248 18.6231 1.83767 18.3939L1.73264 18.3243L1.6355 18.2388C1.28544 17.8855 1.24939 17.3304 1.55638 16.9217L1.6419 16.8246L8.97541 9.55719C9.31685 9.21883 9.84898 9.17253 10.2583 9.45274L10.366 9.54055L14.0109 12.9839L19.3179 7.83121Z"
      fill="#00D1B6"
    />
  ),
})

export const BlockedIcon = createIcon({
  displayName: 'BlockedIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="none"
      d="M18.364 18.364C19.9926 16.7353 21 14.4853 21 12C21 7.02944 16.9706 3 12 3C9.51472 3 7.26472 4.00736 5.63604 5.63604M18.364 18.364C16.7353 19.9926 14.4853 21 12 21C7.02944 21 3 16.9706 3 12C3 9.51472 4.00736 7.26472 5.63604 5.63604M18.364 18.364L5.63604 5.63604"
      stroke="#8A2A2B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
})

export const ChevronRoundedRightIcon = createIcon({
  displayName: 'ChevronRoundedRightIcon',
  viewBox: '0 0 40 40',
  path: (
    <path
      d="M13.9337 27.053C13.2266 27.6423 13.1311 28.6932 13.7203 29.4003C14.2643 30.0531 15.2016 30.1847 15.8987 29.7376L16.0677 29.6137L26.0677 21.2804C26.814 20.6585 26.8637 19.5472 26.2169 18.8601L26.0677 18.7197L16.0677 10.3863C15.3605 9.79707 14.3096 9.89261 13.7203 10.5997C13.1764 11.2525 13.2159 12.1982 13.7814 12.8033L13.9337 12.9471L22.3957 20L13.9337 27.053Z"
      fill="currentColor"
    />
  ),
})

export const PopoutIcon = createIcon({
  displayName: 'PopoutIcon',
  viewBox: '0 0 30 30',
  path: (
    <path
      fill="currentColor"
      d="M 25.980469 2.9902344 A 1.0001 1.0001 0 0 0 25.869141 3 L 20 3 A 1.0001 1.0001 0 1 0 20 5 L 23.585938 5 L 13.292969 15.292969 A 1.0001 1.0001 0 1 0 14.707031 16.707031 L 25 6.4140625 L 25 10 A 1.0001 1.0001 0 1 0 27 10 L 27 4.1269531 A 1.0001 1.0001 0 0 0 25.980469 2.9902344 z M 6 7 C 4.9069372 7 4 7.9069372 4 9 L 4 24 C 4 25.093063 4.9069372 26 6 26 L 21 26 C 22.093063 26 23 25.093063 23 24 L 23 14 L 23 11.421875 L 21 13.421875 L 21 16 L 21 24 L 6 24 L 6 9 L 14 9 L 16 9 L 16.578125 9 L 18.578125 7 L 16 7 L 14 7 L 6 7 z"
    />
  ),
})
